import { useBuilderWidget } from 'components/TasksV2/TaskCreation/contexts/BuilderWidgetContext'
import { useCreationText } from 'components/TasksV2/TaskCreation/hooks/useCreationText'
// PollQuestion.tsx

import React, { memo } from 'react'
import { Flex, Text } from '@chakra-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import { CustomTextareaAutosize } from 'components/helperStyles'
import useLocaleText from 'components/useLocaleText'
import { Subtask } from 'components/TasksV2/TaskCreation/FormStepContext'
import colors from 'constants/colors'
import keys from 'constants/keys'

interface PollQuestionProps {
  subtaskPath: string
  index: number
  field: Subtask
}

const PollQuestion: React.FC<PollQuestionProps> = memo(({ subtaskPath, field }) => {
  const builder = useBuilderWidget()
  const t = useCreationText()
  const { control } = useFormContext()
  const validationMessage = useLocaleText(
    field.type === keys.SUBTASK_TYPES.PRIVATE_POLL ? 'private_poll_st_error' : 't_poll_st_error'
  )
  const t_multipleAnswers = useLocaleText('t_multipleAnswers')
  const t_questionLabel = useLocaleText('t_questionLabel')

  const questionName = `${subtaskPath}.title`

  return (
    <Flex className={builder ? 'creation-question-section' : undefined} direction="column" mt={builder ? '0' : '20px'}>
      <Flex alignItems="center" justifyContent="space-between">
        {builder ? (
          <label htmlFor={questionName}>
            {t.questionLabel} <span className="creation-required-star">*</span>
          </label>
        ) : (
          <Text px="15px" fontSize="14px">
            {t_questionLabel}
          </Text>
        )}
        {!builder && (
          <Flex alignItems="center" style={{ columnGap: '10px' }} mb="5px">
            <Text fontSize="12px" color={colors.analyticGrey}>
              {t_multipleAnswers}
            </Text>
            <Controller
              as={ControlledCustomSwitch}
              name={`${subtaskPath}.is_multi_choice`}
              control={control}
              defaultValue={false}
              valueName="isChecked"
              onChange={([event]) => {
                return event.target.checked
              }}
            />
          </Flex>
        )}
      </Flex>
      <Controller
        as={CustomTextareaAutosize}
        name={questionName}
        id={questionName}
        control={control}
        placeholder={t_questionLabel}
        defaultValue={field.title ?? ''}
        rules={{
          required: validationMessage,
          maxLength: { value: 250, message: validationMessage },
          validate: (value) => {
            return value.trim() !== '' || validationMessage
          },
        }}
        key={questionName}
        maxLength={250}
        minHeight="80px"
        boxShadow="none"
        style={{ border: '2px solid #f0f0f0', borderRadius: '10px', paddingLeft: '10px', paddingRight: '10px' }}
      />
    </Flex>
  )
})

export default PollQuestion
